import { render, staticRenderFns } from "./googleforms-detail.vue?vue&type=template&id=b3371446&"
import script from "./googleforms-detail.vue?vue&type=script&lang=js&"
export * from "./googleforms-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports